import React from 'react'
import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { graphql } from 'gatsby'
import { Blocks, Head } from '@/components/WordPress'
import styled from '@emotion/styled'
import { h3, graphTitle, h4, h5, pStandard, caption } from '@/styles/typography'
import Embed16x9 from '@/components/UI/Embed16x9'
import ArticleCard from '@/components/Articles/Card'
import Sharer from '@/components/UI/Sharer'

const Content = styled.div`
  padding-top: 8rem;
  position: relative;
  z-index: 2;

  header {
    text-align: center;
    h1 {
      ${h3}
      padding-left: 2rem;
      padding-right: 2rem;
      margin-bottom: 2rem;
      @media (max-width: 768px) {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
    .excerpt {
      max-width: 1300px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 2rem;
      padding-right: 2rem;
      margin-bottom: 2rem;
      @media (max-width: 768px) {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      p {
        ${graphTitle};
      }
    }
  }

  .content {
    /* background-color: white; */
    p {
      ${pStandard};
      text-align: justify;
      text-indent: 2em;
      &.has-drop-cap {
        text-indent: 0;
        &::first-letter {
          font-size: 6.6rem;
          line-height: 5.9rem;
          font-weight: 800;
          float: left;
          margin-right: 0.2rem;
        }
      }
    }
    .wp-block {
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 1rem;
      padding-right: 1rem;
      &.block--image {
        max-width: 1280px;
        padding-left: 0;
        padding-right: 0;
        margin-bottom: 3rem;
        margin-top: 2rem;
        figcaption {
          padding-left: 0.1em;
          padding-right: 0.1em;
          padding-top: 6px;
          ${caption}
          @media (orientation: portrait) {
            font-size: 0.9rem;
          }
          &:before {
            content: '▲';
            display: inline-block;
            margin-right: 4px;
            margin-left: 4px;
          }
        }
      }
    }
    .block--heading {
      h2 {
        ${h4};
        padding-bottom: 0.5em;
        text-align: center;
        margin-top: 0.3em;
      }
    }
  }
`

const MoreArticles = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  h3 {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
    ${h5};
  }
`

const PostTemplate = ({
  data: {
    wpPost: {
      excerpt,
      featuredImage,
      title,
      rawContent,
      slug,
      postFormats,
      videofields,
    },
    allWpPost,
    site: {
      siteMetadata: { baseUrl, baseTitle },
    },
  },
}) => {
  const video = videofields?.iframe
  return (
    <Layout>
      <Seo title={`${title} - Interactivo La Tercera`} slug={`${slug}/`} />
      <Content>
        {video && <Embed16x9 iframe={video}></Embed16x9>}
        <div className="content">
          <Blocks
            raw={rawContent}
            extra={
              <div>
                <h2>{title}</h2>
                <div
                  className="excerpt"
                  dangerouslySetInnerHTML={{
                    __html:
                      excerpt +
                      '<p>Revisa la línea de tiempo de todos los eventos ocurridos desde el 18-O en <a href="https://www.latercera.com/la-tercera-domingo/noticia/731-dias-el-camino-recorrido-desde-el-180/DGHMDS442JHX7ETMZYNEDFR3DI/" target="_blank" rel="noopener noreferrer">este artículo</a>.</p>',
                  }}
                />
                <Sharer
                  url={`${
                    baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
                  }${slug}/`}
                  title={title}
                />
              </div>
            }
          />
        </div>
      </Content>
    </Layout>
  )
}

export const postQuery = graphql`
  query PostBySlug($slug: String!) {
    wpPost(slug: { eq: $slug }) {
      title
      rawContent
      slug
      excerpt
      featuredImage {
        node {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
      postFormats {
        nodes {
          name
        }
      }
      videofields {
        iframe
      }
      metafields {
        externalurl
      }
    }
    allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { name: { eq: "Plaza Cero" } } } }
      }
    ) {
      edges {
        node {
          slug
          title
          excerpt
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, quality: 90)
                }
              }
            }
          }
          postFormats {
            nodes {
              name
            }
          }
          metafields {
            externalurl
          }
        }
      }
    }
    site {
      siteMetadata {
        baseUrl: url
        baseTitle: title
      }
    }
  }
`

export default PostTemplate
